import { sanitizeUrl } from './sanitize';

export interface Listing {
  id: string;
  userId: string;
  username: string;
  title: string;
  description: string;
  price: string;
  paymentUrl: string;
  category: string;
  createdAt: number;
}

const KEY = 'authenticulture_listings';

type ListingListener = () => void;
let listeners: ListingListener[] = [];

export function addListingListener(fn: ListingListener): () => void {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}

function notify(): void {
  listeners.forEach(fn => fn());
}

export function getAllListings(): Listing[] {
  const stored = localStorage.getItem(KEY);
  return stored ? JSON.parse(stored) : [];
}

export function getListingsForUser(userId: string): Listing[] {
  return getAllListings()
    .filter(l => l.userId === userId)
    .sort((a, b) => b.createdAt - a.createdAt);
}

export function saveIncomingListing(listing: Listing): void {
  if (!sanitizeUrl(listing.paymentUrl)) return;
  const all = getAllListings();
  if (all.some(l => l.id === listing.id)) return;
  all.push(listing);
  localStorage.setItem(KEY, JSON.stringify(all));
  notify();
}

export function deleteListing(listingId: string, userId: string): boolean {
  const all = getAllListings();
  const idx = all.findIndex(l => l.id === listingId && l.userId === userId);
  if (idx === -1) return false;
  all.splice(idx, 1);
  localStorage.setItem(KEY, JSON.stringify(all));
  notify();
  return true;
}
